import { config } from "../constants";

/**
 * Logo / title helpers only. Brand colors are fixed WIP Sync tokens —
 * do not set tenant theme CSS variables on the document.
 */
export function applyTenantBranding(_tenant) {
  // No-op: app uses fixed design tokens from index.css / Tailwind.
}

export function resolveTenantAssetUrl(path, storageUrl) {
  if (!path) {
    return null;
  }
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  if (path.startsWith("/")) {
    return `${storageUrl}${path}`;
  }
  return `${storageUrl}/${path}`;
}

export function tenantLogoUrl(tenant) {
  return resolveTenantAssetUrl(tenant?.logo_url, config.url.STORAGE_URL);
}

export function tenantAppTitle(tenant) {
  return tenant?.name || "WIP Sync";
}
